import { catchError, useTranslation } from "@opendash/core";
import { Source } from "@opendash/core/dist/types-generated";
import { Tag } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Schedule_Template } from "../../../js/parsegenerated";

type Props = {
  record: Schedule_Template;
};

export default observer((props: Props) => {
  const t = useTranslation();

  const [sources, setSources] = useState<Source[]>([]);

  useEffect(() => {
    const fetch = async () => {
      const [sourcesError, sources] = await catchError(
        props.record.get("sources").query().includeAll().find()
      );

      if (sourcesError) {
        return [];
      }

      return sources as Source[];
    };

    fetch().then(setSources);
  }, [props.record]);

  return sources.map((source: Source) => {
    return (
      <Tag color="default" key={source.id}>
        {t("maintenance:schedule.source.columns.action.source.label", {
          source: source.get("name"),
        })}
      </Tag>
    );
  });
});
